(function() { window.GUID_7ed5c4fc_20d2_43d1_8b8b_21e82f9e0aad = { getGuid: function() { return "7ed5c4fc-20d2-43d1-8b8b-21e82f9e0aad"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-mytodos',
                        callback: function (control, e) {
                            control.$Container.offon('click.todo-pay', 'div.my-todo-box', function (e) {
                                e.stopImmediatePropagation();
                                e.preventDefault();
                                let $this = $(this);
                                CS.DOM.$body.offon("payment-done.todo", function () {
                                    control.RefreshContent();
                                });
                                let wf = new CS.Controls.SportEventFees();
                                wf.ShowModal($this.data('href'));
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=mytodos.js.map
